import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    paddingBottom: 10,
  },
  logo: {
    width: 90,
    height: 50,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  },
  id: {
    fontSize: 12,
    textAlign: 'right',
  },
  sectionTitle: {
    fontSize: 16,
    marginVertical: 10,
    fontWeight: 'bold',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    overflow: 'hidden',
    backgroundColor: '#EAF4FC',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#D9EAFB',
    padding: 5,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  tableRow: {
    flexDirection: 'row',
    padding: 5,
  },
  tableFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: '#ccc',
    padding: 5,
    backgroundColor: '#D9EAFB',
  },
  tableCellLeft: {
    flex: 1,
    fontSize: 10,
    textAlign: 'left',
  },
  tableCellRight: {
    flex: 1,
    fontSize: 10,
    textAlign: 'right',
  },
  tableFooterText: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'left',
  },
  tableFooterValue: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'right',
  },
});

export default styles;
